"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountTaxResponseObjectToJSON = exports.AdAccountTaxResponseObjectFromJSONTyped = exports.AdAccountTaxResponseObjectFromJSON = exports.instanceOfAdAccountTaxResponseObject = exports.AdAccountTaxResponseObjectTypeEnum = void 0;
var runtime_1 = require("../runtime");
var AdAccountTaxStatus_1 = require("./AdAccountTaxStatus");
/**
 * @export
 */
exports.AdAccountTaxResponseObjectTypeEnum = {
    Vat: 'VAT',
    Gst: 'GST',
    Qst: 'QST',
    Abn: 'ABN',
    Cnpj: 'CNPJ',
    Pan: 'PAN',
    Tan: 'TAN'
};
/**
 * Check if a given object implements the AdAccountTaxResponseObject interface.
 */
function instanceOfAdAccountTaxResponseObject(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountTaxResponseObject = instanceOfAdAccountTaxResponseObject;
function AdAccountTaxResponseObjectFromJSON(json) {
    return AdAccountTaxResponseObjectFromJSONTyped(json, false);
}
exports.AdAccountTaxResponseObjectFromJSON = AdAccountTaxResponseObjectFromJSON;
function AdAccountTaxResponseObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AdAccountTaxStatus_1.AdAccountTaxStatusFromJSON)(json['status']),
    };
}
exports.AdAccountTaxResponseObjectFromJSONTyped = AdAccountTaxResponseObjectFromJSONTyped;
function AdAccountTaxResponseObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
        'status': (0, AdAccountTaxStatus_1.AdAccountTaxStatusToJSON)(value.status),
    };
}
exports.AdAccountTaxResponseObjectToJSON = AdAccountTaxResponseObjectToJSON;
